import {Nullable, ReviewFeedbackType} from "../../definitions/types";
import {GraphQLError} from "graphql/error";
import {ReviewFeedbackModel} from "../domain/reviewFeedbackModel";

export class ReviewFeedbackMutationModel {
    private readonly _reviewFeedback?: ReviewFeedbackModel;
    private readonly _errors: readonly GraphQLError[];

    constructor(
        public readonly reviewFeedbackType?: Nullable<ReviewFeedbackType>,
        public readonly graphQLErrors?: readonly GraphQLError[]
    ) {
        this._reviewFeedback = reviewFeedbackType ? new ReviewFeedbackModel(reviewFeedbackType) : undefined;
        this._errors = graphQLErrors || [] as GraphQLError[];
    }

    /**
     * @method reviewFeedback
     * @description Returns the review feedback model if it exists, otherwise undefined.
     * @returns {ReviewFeedbackModel | undefined}
     */
    public get reviewFeedback(): ReviewFeedbackModel | undefined {
        return this._reviewFeedback;
    }

    /**
     * @method hasReviewFeedback
     * @description Returns true if the review feedback model exists, otherwise false.
     * @returns {boolean}
     */
    public get hasReviewFeedback(): boolean {
        return !!this._reviewFeedback;
    }

    /**
     * @method errors
     * @description Returns the GraphQL errors if they exist, otherwise an empty array.
     * @returns {GraphQLError[]}
     */
    public get errors(): readonly GraphQLError[] {
        return this._errors;
    }

    /**
     * @method hasErrors
     * @description Returns true if there are any GraphQL errors, otherwise false.
     * @returns {boolean}
     */
    public get hasErrors(): boolean {
        return this._errors.length > 0;
    }

    /**
     * @method success
     * @description Returns true if there are no GraphQL errors and the review feedback model exists, otherwise false.
     * @returns {boolean}
     */
    public get success(): boolean {
        return !this.hasErrors && this.hasReviewFeedback;
    }
}